import { authRoles } from '@/core'
import { RouteRecordRaw } from 'vue-router'

const { ADMIN, MANUFACTURE } = authRoles

const Projects = () =>
  import(/* webpackChunkName: "login-view" */ './views/pages/index.vue')

const ProjectDetail = () =>
  import(/* webpackChunkName: "login-view" */ './views/pages/detail.vue')

const ProjectOrder = () =>
  import(/* webpackChunkName: "login-view" */ './views/pages/order.vue')

const DailyReport = () =>
  import(/* webpackChunkName: "login-view" */ './views/pages/dailyReport.vue')

const CoilsInventory = () =>
  import(
    /* webpackChunkName: "login-view" */ './views/pages/coilsInventory.vue'
  )

export const projectsModuleRoutes: Array<RouteRecordRaw> = [
  {
    path: '/projects',
    name: 'projects',
    component: Projects,
    meta: {
      title: 'Proyectos',
      auth: {
        roles: [ADMIN, MANUFACTURE],
        redirect: '/auth/login',
        notFoundRedirect: { name: '/404' },
        forbiddenRedirect: '/404',
      },
    },
  },
  {
    path: '/projects/:id',
    name: 'ProjectDetail',
    component: ProjectDetail,
    meta: {
      title: 'Detalle de proyecto',
      auth: {
        roles: [ADMIN, MANUFACTURE],
        redirect: '/auth/login',
        notFoundRedirect: { name: '/404' },
        forbiddenRedirect: '/404',
      },
    },
  },
  {
    path: 'projects/:id/order',
    name: 'ProjectOrder',
    component: ProjectOrder,
    meta: {
      title: 'Orden de manufactura',
      auth: {
        roles: [ADMIN, MANUFACTURE],
        redirect: '/auth/login',
        notFoundRedirect: { name: '/404' },
        forbiddenRedirect: '/404',
      },
    },
  },
  {
    path: 'projects/:id/daily-production/:dailyId',
    name: 'DailyReport',
    component: DailyReport,
    meta: {
      title: 'Log de producción',
      auth: {
        roles: [ADMIN, MANUFACTURE],
        redirect: '/auth/login',
        notFoundRedirect: { name: '/404' },
        forbiddenRedirect: '/404',
      },
    },
  },
  {
    path: 'projects/coils-inventory',
    name: 'CoilsInventory',
    component: CoilsInventory,
    meta: {
      title: 'Inventario de Coils',
      auth: {
        roles: [ADMIN, MANUFACTURE],
        redirect: '/auth/login',
        notFoundRedirect: { name: '/404' },
        forbiddenRedirect: '/404',
      },
    },
  },
]
